import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import ReportFolderButton from '../ReportFolderButton/ReportFolderButton.vue';
import type { TFolder } from '@/_core/entities/report/models/types';
import { useActiveFolderName } from '@/_core/entities/report/utils/report.utils';
import { DEFAULT_FOLDER_NAMES } from '@/_core/entities/report/models/consts';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportSidebar',
  props: {
    foldersData: null,
    isFetchingFolders: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  foldersData?: TFolder[];
  isFetchingFolders?: boolean;
};



const instance = getCurrentInstance();
const route = computed(() => instance?.proxy.$route);
const router = computed(() => instance?.proxy.$router);

const allVulnsFolder = computed(() =>
  props.foldersData?.find((f) => !f.id && f.name === DEFAULT_FOLDER_NAMES.allVulnerabilities)
);

const totalCount = computed(
  () => allVulnsFolder.value?.statistics.reduce((acc, s) => acc + s.count, 0) ?? 0
);

const folders = computed(
  () => props.foldersData?.filter((f) => !!f.id || f.name === DEFAULT_FOLDER_NAMES.mainReport) ?? []
);

const activeFolderName = useActiveFolderName(route);

function selectFolder(name: string) {
  if (name === activeFolderName.value) return;
  router.value?.push({ query: { ...route.value?.query, folderName: name } });
}

return { __sfc: true,props, instance, route, router, allVulnsFolder, totalCount, folders, activeFolderName, selectFolder, ReportFolderButton }
}

})